const _ = require('lodash');
const MatingDamSireDetails = () => import( /* webpackPrefetch: true, webpackChunkName: mating-dam-sire-details"*/ '@/app/views/main-view/breeders/components/mating-dam-sire-details-container/mating-dam-sire-details-container.vue');

// Services
import breedingManagementService from "@/app/services/main/breeder/breeding-management-service.js"
import breedService from "@/app/services/main/breeds/breeds-service.js";

// Mixins
import {
    dateMixins
} from "@/app/mixins/utils/date-mixins";
import {
    toastMessageMixins
} from "@/app/mixins/utils/toast-message-mixins";
import {
    unsavedChangesModalMixins
} from "@/app/mixins/utils/unsaved-changes-mixins.js";
import {
    imageCompressorMixins
} from "@/app/mixins/utils/image-compressor-mixins"

// Components

const InputWeightProgressionTable = () => import( /* webpackPrefetch: true, webpackChunkName: 'input-weight-progression-table' */ "@/app/views/main-view/breeders/components/breeder-edit-litter-component/components/input-weight-progression-table/input-weight-progression-table.vue");

// Constants
import {
    STATUS_CODES,
    SUCCESS_MSG,
    LITTER_STATUS
} from "@/app/constants/constants";

// Third Party libraries
import DatePicker from "vue2-datepicker";
import {
    Bar
} from 'vue-chartjs/legacy';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale

} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, CategoryScale, BarElement, LinearScale);

export default {
    name: "BreederEditLitterComponent",
    components: {
        DatePicker,
        Bar,
        MatingDamSireDetails,
        InputWeightProgressionTable
    },
    mixins: [
        imageCompressorMixins,
        dateMixins,
        toastMessageMixins,
        unsavedChangesModalMixins
    ],
    data() {
        const initialChartDataLabels = [
            "Birth Weight",
        ]
        return {
            isAPILoading: true,
            isAPISubmitLoading: false,
            matingId: null,
            litterId: null,

            breedList: [],

            matingDetails: null,
            littersCount: 0,
            matingName: "",
            damDetails: null,
            sireDetails: null,

            genderOption: ["Male", "Female"],

            puppyList: [],
            initialPuppyList: [],

            // Images
            imageRef: [],
            imageSrc: [],
            fileBlob: null,
            filesToSend: [],
            setAsPrimary: 0,
            updatedImages: [],
            deletedImages: [],
            imageTypeList: ['image/svg', 'image/png', 'image/jpg', 'image/jpeg', 'image/gif', 'image/raw', 'image/webp'],

            weightTrackerList: {
                birthWeight: {},
                periods: {
                    weekOne: {
                        title: "Week One",
                        data: [],
                        notBeforeThisDate: null,
                        notAfterThisDate: null,
                    },
                    weekTwo: {
                        title: "Week Two",
                        data: [],
                        notBeforeThisDate: null,
                        notAfterThisDate: null,
                    },
                    progression: {
                        title: "Progression",
                        data: [],
                        notBeforeThisDate: null,
                        notAfterThisDate: null,
                    },
                }
            },

            initialWeightTrackerList: [],
            breed: {},

            maxWeight: 99999.99,
            maxPuppiesCount: 15,

            isSavingLittersSuccess: false,
            prevRoute: "Puppy List",
            prevRouteTo: '',
            isPuppyImageLoading: false,
            isNewPuppyImage: false,
            isNewForm: false,
            isDuplicate: false,

            breederSysId: null,

            puppyNotes: "",
            puppyNotesHistory: [],
            initialPuppyNotes: "",
            windowWidth: window.innerWidth,
            whelpDate: null,
            defaultDateOfBirth: null,
            weightTrackerListToDelete: [],
            progressionPercentage: [new Array(7), new Array(7), []],
            weightProgressionPercentage: [],
            initialChartDataLabels,
            maxNumEntries: 14,
            chartData: {
                labels: initialChartDataLabels,
                datasets: [{
                    label: "",
                    data: [],
                    backgroundColor: new Array(16).fill("#25BF53"),
                }, ],
            },
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        stacked: true,
                        display: true,
                        title: {
                            display: true,
                            text: 'Day',
                            font: {
                                size: 18,
                                weight: "bold",
                            },
                        }
                    },
                    y: {
                        stacked: true,
                        display: true,
                        title: {
                            display: true,
                            text: 'Weight (kg)',
                            font: {
                                size: 18,
                                weight: "bold",
                            },
                            padding: 18
                        }
                    },
                },
                plugins: {
                    legend: {
                        display: false,
                    },
                    title: {
                        display: true,
                        text: "Puppy Weight Progression",
                        font: {
                            size: 20,
                            weight: "bold",
                        },
                        padding: {
                            bottom: 25,
                            top: 25,
                        },
                        align: "center",
                    },
                    tooltip: {
                        callbacks: {
                            label: (context) => {
                                const value = context.raw ? parseFloat(context.raw) : context.raw;
                                return `${value} kg`;
                            }
                        }
                    },
                },
            },
            typeOfBirth: null
        };
    },
    computed: {
        showUploadButton() {
            return (
                this.imageSrc.length < 7
            )
        },
        allowUpdateOfImages() {
            return (
                (!this.isNewForm && (this.matingDetails.status === "ACTIVE"))
            )
        },
        graphWidth() {
            let width = null; // will let the library handle the default width
            if (this.windowWidth <= 767) {
                width = 200;
            }
            return width;
        },
    },
    async created() {
        if (this.$route.query) {
            this.matingId = this.$route.params.id;
            this.litterId = this.$route.params.litterId;
            this.breederSysId = this.$route.params.breederSysId;
            try {
                this.isAPILoading = true;

                await this.getBreedList();
                await this.getDamAndSireMatingDetails(this.$route.params.matingId, this.$route.params.litterId, this.$route.params.breederSysId);
            } catch (err) {
                this.showGenericErrorToast();
            } finally {
                this.isAPILoading = false;
            }

            if (this.$route.query.from === "mating-details") {
                this.prevRoute = "Mating Details";
            }
        }
    },
    watch: {
        weightTrackerList: {
            immediate: true,
            deep: true,
            handler(newValue) {
                if (newValue) {
                    const weightList = newValue;

                    // ************** computing the weight progress for each period (weeks) ************** //
                    Object.keys(weightList.periods).forEach((periodKey, periodIndex, periodsArr) => {
                        const currentPeriod = weightList.periods[periodKey];

                        const prevPeriodKey = periodsArr[periodIndex - 1];
                        const prevPeriod = prevPeriodKey ? weightList.periods[prevPeriodKey] : null;

                        currentPeriod.data.forEach((currentEntry, entryIndex, arr) => {
                            // get previous values of the current entry, only get the values with data
                            const prevValues = arr.slice(0, entryIndex).filter((entity) => parseFloat(entity.weight));
                            let prevEntry = prevValues[prevValues.length - 1]; // fetch the previous most entry with data

                            // consider the birthWeight if the current week is week one (for the first day)
                            if (periodKey === "weekOne" && entryIndex === 0) {
                                prevEntry = weightList.birthWeight;
                            } else if (entryIndex === 0) {
                                // get the last entry on the previous period or week
                                prevEntry = prevPeriod ? prevPeriod.data[prevPeriod.data.length - 1] : null;
                            }

                            if (prevEntry) {
                                // percentage computation
                                const previousValue = parseFloat(prevEntry.weight || 0);
                                const currentValue = parseFloat(currentEntry.weight || 0);

                                if (currentValue) {
                                    // Update the progression percentage at the correct period and entry index
                                    const percentage = this.computePercentageDifference(previousValue, currentValue);

                                    // Ensure reactivity by using $set for both period and entry
                                    this.$set(this.progressionPercentage[periodIndex], entryIndex, percentage);

                                    // Update the chart data
                                    this.chartData.datasets[0].data[entryIndex] = currentEntry.weight || 0;
                                } else {
                                    // If no current value, set the progression percentage to 0
                                    this.$set(this.progressionPercentage[periodIndex], entryIndex, 0);
                                }
                            }
                        });

                    });

                    // ************** setting the inputted weight values (and bg colors) in the graph and its x-axis date values ************** //

                    this.chartData.labels = JSON.parse(JSON.stringify(this.initialChartDataLabels)); // deep clone to remove its reference from the object initialChartDataLabels
                    this.chartData.datasets[0].data = [];

                    const periodData = Object.values(weightList.periods)
                        .map((period) => period.data)
                        .flat();
                    const allWeightInputs = [weightList.birthWeight, ...periodData];

                    allWeightInputs.forEach((currentEntry, index, arr) => {
                        this.chartData.datasets[0].data[index] = currentEntry.weight || 0;
                        this.chartData.datasets[0].data = [...this.chartData.datasets[0].data]; // force rerender of graph

                        // get previous values of the current entry, only get the values with data
                        const prevValues = arr.slice(0, index).filter((entity) => parseFloat(entity.weight));
                        const prevEntry = prevValues[prevValues.length - 1]; // fetch the previous most entry with data

                        if (prevEntry) {
                            // display the current entry with red if it's less than the entry (with data) before it
                            if (prevEntry.weight && parseFloat(currentEntry.weight || 0) < parseFloat(prevEntry.weight || 0)) {
                                this.chartData.datasets[0].backgroundColor[index] = "red";
                            } else {
                                this.chartData.datasets[0].backgroundColor[index] = "#25BF53";
                            }
                        }

                        // exclude index 0 (birth weight) for formatting the dates in the x-axis of the graph
                        if (index > 0) {
                            this.chartData.labels[index] = this.formatDate(currentEntry.entry);
                        }
                    });

                }
            }
        }
    },
    methods: {
        computePercentageDifference(prevWeight, currentWeight) {
            // Check if either value is NaN
            if (isNaN(prevWeight) || isNaN(currentWeight)) {
                return 0;
            }

            const difference = currentWeight - prevWeight;
            const percentageDiff = (difference / prevWeight) * 100;

            return isFinite(percentageDiff) ? percentageDiff.toFixed(2) : 0;
        },
        async onSubmitDetails() {
            try {
                this.isAPISubmitLoading = true;
                const littersWithValues = this.puppyList.filter((puppy) => {
                    const {
                        gender,
                        identifyingMarks,
                        collarColour,
                        puppyName,
                        dateOfBirth,
                        birthWeight
                    } = puppy;
                    if (
                        gender ||
                        (identifyingMarks && identifyingMarks.trim()) ||
                        (collarColour && collarColour.trim()) ||
                        (puppyName && puppyName.trim()) ||
                        this.breed ||
                        dateOfBirth ||
                        birthWeight
                    ) {
                        return true;
                    }

                    return false;
                });

                if (littersWithValues.length === 0) {
                    await this.$swal({
                        text: "Please fill out litter details.",
                        imageHeight: "30px",
                        imageUrl: `${require("@/assets/images/_shared/sad-dog.png")}`,
                        imageAlt: "Sad Dog",
                        confirmButtonText: "Got it",
                        showCloseButton: true,
                    });

                    return;
                }

                // Display error validations for entries with missing dates or weights
                for (const [periodKey, currentPeriod] of Object.entries(this.weightTrackerList.periods)) {
                    if (currentPeriod && currentPeriod.data) {
                        const entriesWithEmptyWeights = currentPeriod.data.filter(({
                            id,
                            weight
                        }) => id && parseFloat(weight || 0) === 0).map(({
                            id
                        }) => id);
                        this.weightTrackerListToDelete = [...this.weightTrackerListToDelete, ...entriesWithEmptyWeights];

                        currentPeriod.data = currentPeriod.data
                            .filter(({
                                weight
                            }) => parseFloat(weight || 0) > 0) // Only keep entries with a weight
                            .map(({
                                entry,
                                weight,
                                ...rest
                            }) => ({
                                entry,
                                weight: weight != null ? weight : 0,
                                isError: !entry, // Mark as error if entry is missing (shouldn't happen due to the filter)
                                ...rest,
                            }));
                    }
                }

                const areSomeDatesEmpty = Object.values(this.weightTrackerList.periods)
                    .map((period) => period.data)
                    .flat()
                    .some((data) => Boolean(data.isError));

                if (areSomeDatesEmpty) {
                    return;
                }

                const littersToSave = this.puppyList.map((puppy) => {
                    const {
                        id,
                        gender,
                        identifyingMarks,
                        collarColour,
                        puppyName,
                        dateOfBirth,
                        matingId
                    } = puppy;

                    const updatedWeightTracker = Object.entries(this.weightTrackerList.periods).reduce((acc, [periodKey, currentPeriod]) => {
                        const periodData = currentPeriod.data.map((entryObj) => {
                            return {
                                period: periodKey,
                                id: entryObj.id === "" ? null : entryObj.id,
                                litterId: this.litterId,
                                status: entryObj.status,
                                weight: entryObj.weight === "" ? null : parseFloat(entryObj.weight),
                                unitsOfWeight: entryObj.unitsOfWeight.toLocaleLowerCase(),
                                entry: this.dateToISO(entryObj.entry),
                            };
                        });

                        acc.push(periodData);

                        return acc;
                    }, []);

                    const birthWeight = this.weightTrackerList.birthWeight.weight;

                    const payload = {
                        id,
                        matingId,
                        breedId: this.breed ? this.breed.id : null,
                        name: puppyName,
                        status: LITTER_STATUS.ACTIVE,
                        dateOfBirth: dateOfBirth ? this.dateToISO(dateOfBirth) : null,
                        identifyingMarks,
                        collarColour,
                        birthWeight: birthWeight ? birthWeight : null,
                        unitsOfWeight: "kg",
                        gender,
                        breederSysId: this.matingDetails.breederSysId,
                        imageRef: this.imageRef, //Image reference of the newly added photo
                        updatedImages: this.updatedImages, //New primary photo
                        deletedImages: this.deletedImages, //Images to be deleted in the database
                        weightTracker: updatedWeightTracker.flat(),
                        weightTrackerListToDelete: this.weightTrackerListToDelete,
                    };

                    return payload;
                });

                const puppyDetails = {
                    ...littersToSave[0],
                    note: this.puppyNotes
                };

                const littersSavingResponse = await breedingManagementService.saveLitterPuppyDetails(this.breederSysId, this.litterId, puppyDetails);


                if (littersSavingResponse.status !== STATUS_CODES.SUCCESS) {
                    await this.$swal({
                        html: "<span>An error occurred while saving the added puppies. <br> <strong>Please try saving again.</strong> </span>",
                        imageHeight: "30px",
                        imageUrl: `${require("@/assets/images/_shared/sad-dog.png")}`,
                        imageAlt: "Sad Dog",
                        confirmButtonText: "Got it",
                        showCloseButton: true,
                    });
                } else {
                    const {
                        SUCCESS_UPDATE_LITTER
                    } = this.toastMessages.litters();
                    this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_UPDATE_LITTER);
                }

                // get the data return back by POST to have the saved values with IDs in order to differentiate them from the new data
                if (littersSavingResponse && littersSavingResponse.data && !littersSavingResponse.data.errors) {
                    this.puppyList = [];
                    this.initialPuppyList = [];
                    this.puppyList.push(littersSavingResponse.data);

                    const details = {
                        birthWeight: littersSavingResponse.data ? littersSavingResponse.data.birthWeight : 0,
                        dateOfBirth: littersSavingResponse.data.dateOfBirth,
                        weightTracker: littersSavingResponse.data.weightTracker,
                    };

                    this.populateWeightTrackerList(details);

                    this.puppyList = this.puppyList.map((puppy) => {
                        const {
                            dateOfBirth,
                            breedId,
                            name
                        } = puppy;
                        this.breed = breedId ? this.breedList.find((breedItem) => breedItem.id === breedId) : null;

                        return {
                            ...puppy,
                            puppyName: name,
                            breed: this.breed,
                            dateOfBirth: dateOfBirth ? new Date(dateOfBirth) : null,
                        };
                    });

                    // notes
                    const noteHistory = littersSavingResponse.data.litterNoteHistory;
                    if (noteHistory && noteHistory.length > 0) {
                        this.puppyNotesHistory = noteHistory.filter((noteData) => noteData.note !== "");
                        this.puppyNotes = noteHistory[0].note;
                    }

                    this.chartData.datasets[0].data = [...this.chartData.datasets[0].data]; // this is needed to force the chart to rerender

                    // deep copy
                    this.initialPuppyList = JSON.parse(JSON.stringify(this.puppyList));
                } else if (littersSavingResponse.data.errors) {
                    this.showCustomErrorToast("Invalid file format", littersSavingResponse.data.errors[0].message);
                }
            } catch (err) {
                this.showGenericErrorToast();
            } finally {
                this.isAPISubmitLoading = false;
            }
        },
        async getDamAndSireMatingDetails(matingId, litterId, breederSysId) {
            if (!matingId) {
                return;
            }
            try {
                this.isAPILoading = true;
                const matingDetailsResponse =
                    await breedingManagementService.getAdminDamAndSireMatingDetails(
                        breederSysId,
                        matingId
                    );

                if (matingDetailsResponse.status === STATUS_CODES.SUCCESS) {
                    const {
                        data: matingDetails
                    } = matingDetailsResponse;

                    this.damDetails = matingDetails.damDetails;
                    this.sireDetails = matingDetails.sireDetails;
                    this.matingName = matingDetails.alias;
                    this.littersCount = matingDetails.littersCount;
                    this.matingDetails = matingDetails;
                    const litterDetailsResponse =
                        await breedingManagementService.getDamAndSireLitterDetails(
                            breederSysId,
                            litterId
                        );
                    if (litterDetailsResponse.status === STATUS_CODES.SUCCESS) {
                        this.puppyList.push(litterDetailsResponse.data)
                        
                        this.puppyList[0].dateOfBirth = this.puppyList[0].dateOfBirth ? new Date(this.puppyList[0].dateOfBirth): null
                        this.breed = this.breedList.find(breed => breed.id === this.puppyList[0].breedId);
                        this.puppyList[0].breed = this.breed

                        // set the birth weight
                        this.chartData.datasets[0].data[0] = litterDetailsResponse.data.birthWeight || 0;
                        this.weightProgressionPercentage.push(0);

                         // set the birth weight
                         this.chartData.datasets[0].data[0] = litterDetailsResponse.data.birthWeight || 0;
                         this.weightProgressionPercentage.push(0);
 
                         let dateOfBirth = litterDetailsResponse.data.dateOfBirth ? new Date(litterDetailsResponse.data.dateOfBirth) : null;
                         if(dateOfBirth){
                             dateOfBirth.setDate(dateOfBirth.getDate() + 1); // add 1 to exclude the DOB on the first day datepicker
                         } else if(this.whelpDate){
                             dateOfBirth = this.whelpDate ? new Date(this.whelpDate) : null;
                             dateOfBirth.setDate(dateOfBirth.getDate() + 1); 
                         } else {
                             dateOfBirth = new Date(); // fallback to today
                         }
 
                         const details = { 
                             birthWeight: litterDetailsResponse.data ? litterDetailsResponse.data.birthWeight : 0, 
                             dateOfBirth, 
                             weightTracker: litterDetailsResponse.data.weightTracker
                         };
                         this.populateWeightTrackerList(details, true);
                         const noteHistory = litterDetailsResponse.data.litterNoteHistory;
                         if(noteHistory && noteHistory.length > 0){
                             this.puppyNotesHistory = noteHistory.filter(noteData => noteData.note !== "");
                             this.puppyNotes = noteHistory[0].note;
 
                             this.initialPuppyNotes = this.puppyNotes;
                         }
                         this.initialPuppyList = JSON.parse(JSON.stringify(this.puppyList));

                        this.imageSrc = []
                        if(this.puppyList[0].images) {
                            this.puppyList[0].images.forEach((img, i) => {
                                if (img.primary) {
                                    this.setAsPrimary = i
                                }
                            })
                        }
                        this.imageSrc = this.puppyList[0].images;
                    }
                } else {
                    const {
                        ERROR_GET_MATING_DETAILS
                    } =
                    this.toastMessages.mating();
                    this.showAPIErrorToast(
                        ERROR_GET_MATING_DETAILS,
                        matingDetailsResponse
                    );
                }
            } catch (err) {
                console.log(`err ::: `, err)
                this.showGenericErrorToast();
            } finally {
                this.isAPILoading = false;
            }
        },

        async populateWeightTrackerList(details, isInitial = false){
            const { birthWeight, dateOfBirth, weightTracker} = details;

            if(!dateOfBirth) return;

            const birthWeightEntry = {
                id: 'birthWeight',
                litterId: '',
                status: '',
                weight: birthWeight || 0,
                unitsOfWeight: 'kg',
                entry: 'Birth Weight',
            }

            if(birthWeight){
                this.weightTrackerList.birthWeight = birthWeightEntry;
            }

            let daysWeek = 7; 
            let daysTracker = 0;

            for (const periodKey in this.weightTrackerList.periods) {
                const currentPeriod = this.weightTrackerList.periods[periodKey];

                const dateOfBirthCopy = new Date(dateOfBirth);
                dateOfBirthCopy.setDate(new Date(dateOfBirth).getDate());

                const notBeforeThisDate = new Date(dateOfBirthCopy);
                notBeforeThisDate.setDate(dateOfBirthCopy.getDate() + daysTracker);
                currentPeriod.notBeforeThisDate = notBeforeThisDate;

                daysTracker += daysWeek;

                const notAfterThisDate = new Date(dateOfBirthCopy);
                notAfterThisDate.setDate(dateOfBirthCopy.getDate() + daysTracker);
                currentPeriod.notAfterThisDate = notAfterThisDate;

                if(weightTracker && weightTracker[periodKey]){
                    currentPeriod.data = [...weightTracker[periodKey].data];
                    currentPeriod.data = currentPeriod.data.map(entryObj => ({...entryObj, weight: parseFloat(entryObj.weight || 0).toFixed(2), entry: new Date(entryObj.entry)}))
                }
            }

            if(isInitial){
                this.initialWeightTrackerList = JSON.parse(JSON.stringify(this.weightTrackerList));
            }

        },
        hasImageUrl(source) {
            if (!source) {
                return require('@/assets/images/_shared/dog-purchase.png');
            }

            return source;
        },
        sortAlphabetically(items) {
            const sortedItems = items.sort(function(a, b) {
                return a.name.localeCompare(b.name);
            });
            return sortedItems;
        },
        async getBreedList() {
            try {
                this.isAPILoading = true;
                const breedsResponse = await breedService.getBreeds();

                if (breedsResponse.status === STATUS_CODES.SUCCESS) {
                    const otherBreedOptions = breedsResponse.data.data.slice(0, 4);
                    const breeds = this.sortAlphabetically(breedsResponse.data.data.slice(4, breedsResponse.data.count));

                    // remove "Breed not specified", it has id = 0
                    this.breedList = [...otherBreedOptions, ...breeds].filter(
                        (breed) => breed.id != 0
                    );
                } else {
                    const {
                        ERROR_GET_BREED_LIST
                    } = this.toastMessages.breed();
                    this.showAPIErrorToast(ERROR_GET_BREED_LIST, breedsResponse);
                }
            } catch (err) {
                this.showGenericErrorToast();
            } finally {
                this.isAPILoading = false;
            }
        },

        notAfterToday(date) {
            return date > new Date();
        },
        validateBirthWeight(event, index) {
            const field = event.target;

            setTimeout(() => {
                // Use the regex to match the pattern: digits followed by an optional decimal point and more digits
                const regex = /^\d*\.?\d*/;

                // Check if the field has a valid value (exists and is not null/undefined)
                if (field && field.value) {
                    // Execute the regex and check if a match was found
                    const match = regex.exec(field.value);

                    // If the match is found, use the first match; otherwise, set the value to an empty string
                    let sanitizedInput = match ? match[0] : '';

                    // Apply the sanitized input to the field
                    event.target.value = sanitizedInput;


                    // Set the sanitized value back to the model
                    this.$set(this.puppyList[index], 'birthWeight', sanitizedInput);
                }
            }, 0);
        },
        validatePuppyWeight(event, index) {
            const field = event.target;

            setTimeout(() => {

                // Use the regex to match the pattern: digits followed by an optional decimal point and more digits
                const regex = /^\d*\.?\d*/;


                // Check if the field has a valid value (exists and is not null/undefined)
                if (field && field.value) {
                    // Execute the regex and check if a match was found
                    const match = regex.exec(field.value);

                    // If the match is found, use the first match; otherwise, set the value to an empty string
                    let sanitizedInput = match ? match[0] : '';

                    // Apply the sanitized input to the field
                    event.target.value = sanitizedInput;

                    // Set the sanitized value back to the model
                    this.puppyList[0].weightTracker[index].weight = sanitizedInput
                    // this.$set(this.puppyList[0].weightTracker[index], modelValue, sanitizedInput);
                } else {
                    this.puppyList[0].weightTracker[index].weight = ''
                }

            }, 0);
        },
        beforeEnter(el) {
            el.style.opacity = 0;
        },
        enter(el, done) {
            el.offsetHeight; // trigger reflow
            el.style.transition = 'opacity 0.5s';
            el.style.opacity = 1;
            done();
        },
        leave(el, done) {
            el.style.transition = 'opacity 0.5s';
            el.style.opacity = 0;
            done();
        },
        compareDeepEqual(obj1, obj2) {
            if (obj1 === obj2) return true; // Check reference equality

            if (obj1 == null || obj2 == null || typeof obj1 !== 'object' || typeof obj2 !== 'object') {
                return false; // One is null or they are not both objects
            }

            const keys1 = Object.keys(obj1);
            const keys2 = Object.keys(obj2);

            if (keys1.length !== keys2.length) return false; // Different number of keys

            for (let key of keys1) {
                if (!keys2.includes(key) || !this.compareDeepEqual(obj1[key], obj2[key])) {
                    return false; // Key mismatch or nested value mismatch
                }
            }

            return true; // All keys and values match
        },
        formatNumberField(event, index) {
            const field = event.target;

            setTimeout(() => {
                // Check if the field has a valid value (exists and is not null/undefined)
                if (field && field.value) {

                    const number = parseFloat(field.value).toFixed(2)
                    let sanitizedInput = null
                    if (field < 0) {
                        sanitizedInput = 0
                    } else {
                        sanitizedInput = isNaN(number) ? parseFloat("0").toFixed(2) : number
                    }

                    // // Apply the sanitized input to the field
                    event.target.value = sanitizedInput;

                    // Set the sanitized value back to the model
                    this.puppyList[0].weightTracker[index].weight = sanitizedInput
                    this.weightTrackerList[index].weight = sanitizedInput
                    // this.$set(this.puppyList[0].weightTracker[index], modelValue, sanitizedInput);
                }

            }, 0);
        },
    },

    // async beforeRouteLeave(to, from, next) {
    //     const isFormModified = ((JSON.stringify(this.puppyList) !== JSON.stringify(this.initialPuppyList))
    //         || (JSON.stringify(this.puppyList[0].breed) !== JSON.stringify(this.breed)))

    //     if(!this.isSavingLittersSuccess && isFormModified){
    //         const result = await this.showUnsavedChangesModal();

    //         if (result.value) {
    //             next(true);
    //         } else {
    //             next(false);
    //         }

    //     } else {
    //         next(true);
    //     }
    // },

};